/**
 * @fileoverview Hook for accessing palette mode context for theme switching.
 */

import * as React from 'react';
import { PaletteModeContext } from '../contexts';
import type { PaletteModeContextValue } from '../types';

/**
 * Returns the palette mode context for controlling light/dark theme.
 */
export function usePaletteMode(): PaletteModeContextValue {
  return React.useContext(PaletteModeContext);
}

